import { setCurrentData } from "Utils";

const initialDataState = {
  fetching: false,
  fetched: false,
  data: null,
  error: null,
  uen: null
};

export const dataReducer = (state = initialDataState, action) => {
  let result = { ...state };

  switch (action.type) {
    case "SET_CURRENT_DATA_UEN": {
      result = { ...state, uen: action.uen };
      break;
    }
    case "SET_DATA": {
      result = { ...state, data: action.data };
      break;
    }

    case "FETCH_DATA_PENDING": {
      result = { ...initialDataState, fetching: true };
      break;
    }
    case "FETCH_DATA_FULFILLED": {
      result = {
        ...state,
        fetching: false,
        fetched: true,
        data: action.payload
      };
      break;
    }
    case "FETCH_DATA_REJECTED": {
      result = {
        ...initialDataState,
        error: action.payload
      };
      break;
    }
    default:
      return state;
  }
  setCurrentData(result);

  return result;
};

const initialOrganizationListState = {
  fetching: false,
  fetched: false,
  items: [],
  selected: [],
  error: null,
  nbResult: 0,
  pageSize: 10,
  paginationPage: 1,
  statusCounts: { NOTPREPARED: 0, PREPARED: 0, PRESENTED: 0 },
  filter: {
    name: "",
    sortMetrics: [],
    type: [],
    juridicalForms: [],
    collaborators: [],
    roleCollaborator: "",
    //configState: [],
    configState: "",
    clientTypes: [],
    year: new Date().getFullYear() - 1,
    presentationState: "",
    clientCRMTypes: [],
    clientCRMGroup: []
  }
};

export const organizationsReducer = (
  state = initialOrganizationListState,
  action
) => {
  switch (action.type) {
    case "INIT_ORGANIZATION_LIST_FILTER": {
      return initialOrganizationListState;
    }
    case "SET_ORGANIZATIONS_LIST": {
      return { ...state, items: action.organizations };
    }
    case "FETCH_ORGANIZATIONS_LIST_PENDING": {
      return { ...state, fetched: false, fetching: true };
    }
    case "FETCH_ORGANIZATIONS_LIST_FULFILLED": {
      const { data, nbResult, statusCounts } = action.payload;
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        statusCounts: statusCounts,
        items: data || [],
        selected: [],
        nbResult: nbResult
      };
    }
    case "FETCH_ORGANIZATIONS_LIST_REJECTED": {
      let error = action.payload;
      if (!error.response) {
        error = {
          title: error,
          code: 500
        };
      } else {
        switch (error.response.status) {
          case 404:
            error = {
              title: error.response.data.title,
              code: 404
            };
            break;
          default:
        }
      }
      return {
        ...state,
        fetching: false,
        items: [],
        error
      };
    }
    case "SET_ORGANIZATIONS_LIST_PAGINATION_PAGE": {
      return { ...state, paginationPage: action.pageNumber };
    }
    case "SET_ORGANIZATIONS_LIST_PAGE_SIZE": {
      return {
        ...state,
        pageSize: action.pageSize,
        paginationPage: 1
      };
    }
    case "SET_ORGANIZATIONS_SELECTED_ITEM": {
      return {
        ...state,
        selected: action.selected
      };
    }
    case "SET_ORGANIZATIONS_LIST_FILTER_TITLE": {
      return {
        ...state,
        filter: { ...state.filter, name: action.title },
        paginationPage: 1
      };
    }
    case "SET_ORGANIZATIONS_LIST_FILTER_TYPE": {
      return {
        ...state,
        filter: { ...state.filter, type: action.societyType },
        paginationPage: 1
      };
    }
    case "FETCH_ORGANIZATIONS_LIST_FILTER_IMPORTED_BALANCE": {
      return {
        ...state,
        filter: { ...state.filter, importedBalance: action.importedBalance },
        paginationPage: 1
      };
    }
    case "SET_ORGANIZATIONS_LIST_FILTER_CONFIG_STATE": {
      return {
        ...state,
        filter: { ...state.filter, configState: action.configState },
        paginationPage: 1
      };
    }
    case "SET_ORGANIZATIONS_LIST_FILTER_YEAR": {
      return {
        ...state,
        filter: { ...state.filter, year: action.year },
        paginationPage: 1
      };
    }
    case "SET_ORGANIZATIONS_LIST_FILTER_PRESENTATIONS": {
      return {
        ...state,
        filter: {
          ...state.filter,
          presentationState: action.presentationState
        },
        paginationPage: 1
      };
    }
    case "SET_ORGANIZATIONS_LIST_SORT_METRICS": {
      return {
        ...state,
        filter: { ...state.filter, sortMetrics: action.sort },
        paginationPage: 1
      };
    }
    case "SET_ORGANIZATIONS_LIST_FILTER_JURIDICAL_FORM": {
      return {
        ...state,
        filter: { ...state.filter, juridicalForms: action.juridicalForm },
        paginationPage: 1
      };
    }
    case "SET_FILTER_COLLABORATOR": {
      return {
        ...state,
        filter: { ...state.filter, collaborators: action.collaborators },
        paginationPage: 1
      };
    }
    case "SET_FILTER_ROLE_COLLABORATOR": {
      return {
        ...state,
        filter: { ...state.filter, roleCollaborator: action.roleCollaborator },
        paginationPage: 1
      };
    }
    case "SET_CLIENT_CRM_TYPE": {
      return {
        ...state,
        filter: { ...state.filter, clientCRMTypes: action.clientCRMTypes }
      };
    }
    case "SET_CLIENT_CRM_GROUP": {
      return {
        ...state,
        filter: { ...state.filter, clientCRMGroup: action.clientCRMGroup }
      };
    }
    default:
      return state;
  }
};

const initialJuridicalFormSuggestionsState = {
  fetching: false,
  fetched: false,
  items: [],
  selected: [],
  error: null
};
export const juridicalFormSuggestionsReducer = (
  state = initialJuridicalFormSuggestionsState,
  action
) => {
  switch (action.type) {
    case "INIT_ORGANIZATIONS_JURIDICAL_FORM_SUGGESTIONS": {
      return initialJuridicalFormSuggestionsState;
    }
    case "FETCH_ORGANIZATIONS_JURIDICAL_FORM_SUGGESTIONS_PENDING": {
      return { ...state, fetching: true };
    }
    case "FETCH_ORGANIZATIONS_JURIDICAL_FORM_SUGGESTIONS_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: action.payload.data.data
      };
    }
    case "FETCH_ORGANIZATIONS_JURIDICAL_FORM_SUGGESTIONS_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }
    default:
      return state;
  }
};

const initialAssociationDashboardState = {
  fetching: false,
  fetched: false,
  data: [],
  error: null
};
export const associationDashboardStateReducer = (
  state = initialAssociationDashboardState,
  action
) => {
  switch (action.type) {
    case "INIT_ASSOCIATION_DASHBOARD": {
      return initialAssociationDashboardState;
    }
    case "FETCH_ASSOCIATION_DASHBOARD_PENDING": {
      return { ...state, fetched: false, fetching: true };
    }
    case "FETCH_ASSOCIATION_DASHBOARD_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        data: action.payload
      };
    }
    case "FETCH_ASSOCIATION_DASHBOARD_REJECTED": {
      return {
        ...state,
        fetching: false,
        error: action.payload
      };
    }
    case "SET_SELECTED_PRINCIPAL_DASHBOARD": {
      return {
        ...state,
        data: action.payload
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/data.js